<template>
    <div :id="chartId"/>
</template>

<script>
import {ref, toRefs, watch, onMounted} from "vue";

const echarts = require("echarts");
export default {
    name: "Chart",
    props: {
        option: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    setup(props) {
        const chartId = ref(`chart${new Date().getTime() + ((Math.random() * 1000).toFixed(0) + "")}`);
        const chartInit = () => {
            let myChart = echarts.init(document.getElementById(chartId.value));
            myChart.clear();
            window.addEventListener("resize", () => {
                myChart.resize();
            });
            myChart.setOption(props.option);
        };
        const {option} = toRefs(props);
        watch(option, () => {
            setTimeout(() => {
                chartInit();
            }, 300);
        });
        onMounted(() => {
            setTimeout(() => {
                chartInit();
            }, 300);
        });
        return {
            chartId,
        };
    },
};
</script>

<style scoped>
</style>
